/**
 * @author Ariel
 * @date 2021-12-22
 * @desc 短视频查看
 */
import React from "react";
import { connect } from 'dva';
import { Link } from 'dva/router';
import { Descriptions } from 'antd';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import ModalPlayer from './components/modalPlayer'

let { WizContainer, modelUtils, ossFileUtils } = framework_tool
let { WizCard, WizSpin, WizButton } = component_tool
let { Session } = utils_tool

const _getValue = (type, key) => {
  const values = {
    type: {
      0: '培训视频',
      1: '店端视频',
    },
    state: {
      0: '取消发布',
      1: '发布',
      2: '屏蔽'
    },
    commentState: {
      0: '关闭',
      1: '开启'
    },
    shareState: {
      0: '关闭',
      1: '开启'
    }
  }
  return values[type][key]
}

class ShortVideoLook extends WizContainer {
  componentName = 'shortVideoLook'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location) {
      if (history.location.pathname === '/shortVideo/look') {
        if (history.location.record) {
          detailInfo = history.location.record
          Session.set('detailInfo', detailInfo)
        } else {
          detailInfo = Session.get('detailInfo') || {}
        }
      }
    }
    this.state = {
      visible:false,
      videoUrl:''
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo && this.detailInfo.id) {
      this.doAction({
        path: 'shortVideo/look',
        payload: {
          key: 'shortVideoInfo',
          apiParams: { id: this.detailInfo.id }
        }
      })
    }
  }

  propsAndStateOnChange = {
    shortVideoInfo: this._shortVideoInfoOver.bind(this),
  }

  _shortVideoInfoOver(nextProps, nextState) {
    if (nextProps.shortVideoInfo.code == 1) {
      this.detailInfo = nextProps.shortVideoInfo.data
    } else {
      wizNotice.error('查询失败：' + nextProps.shortVideoInfo.msg);
    }
    return true;
  }

  getImgInfo = (image) => {
    if (image) {
      return <div>
        <div>
          <img src={getOssFilePath(image)} />
        </div>
      </div>
    }
  }

  _render() {
    const items = this.detailInfo
    let labelIds = []
    items['labelIds'] && items['labelIds'].length && items['labelIds'].forEach(item => {
      labelIds.push(item.name)
    })
    items['labelNames'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''
    let categoryIds = []
    items['categoryIds'] && items['categoryIds'].length && items['categoryIds'].forEach(item => {
      categoryIds.push(item.name)
    })
    items['categoryNames'] = categoryIds && categoryIds.length > 0 ? categoryIds.join(",") : ''

    let {visible,videoUrl} = this.state
    const modalProps = {
      visible,
      videoUrl,
      setVisible: ()=> this.setState({ visible: false, videoUrl: '' })
    }
    return (
      <React.Fragment>
        <WizCard>
          <WizSpin tip={'加载中'} spinning={this.props.shortVideoLoading}>
            <Descriptions column={1} style={{ paddingLeft: 25 }} bordered={true}>
              <Descriptions.Item label='视频文件'>
                <WizButton style={{paddingLeft:0}} type='link' onClick={()=>this.setState({ visible: true, videoUrl: items.video })}>播放</WizButton>
              </Descriptions.Item>
              <Descriptions.Item label='标题'>{items.title}</Descriptions.Item>
              <Descriptions.Item label='介绍'>{items.intro}</Descriptions.Item>
              <Descriptions.Item label='标签'>{items.labelNames}</Descriptions.Item>
              <Descriptions.Item label='分类'>{items.categoryNames}</Descriptions.Item>
              <Descriptions.Item label='发布终端'>{items.publishTerminalCh}</Descriptions.Item>
              <Descriptions.Item label='封面'>{this.getImgInfo(items.videoImg)}</Descriptions.Item>
              <Descriptions.Item label='发布人'>{items.fullName}</Descriptions.Item>
              <Descriptions.Item label='账号'>{items.userName}</Descriptions.Item>
              <Descriptions.Item label='发布时间'>{items.releaseTime}</Descriptions.Item>
              <Descriptions.Item label='状态'>{_getValue('state',items.state)}</Descriptions.Item>
              <Descriptions.Item label='评论状态'>{_getValue('commentState',items.state)}</Descriptions.Item>
              <Descriptions.Item label='分享状态'>{_getValue('shareState',items.state)}</Descriptions.Item>
            </Descriptions>
          </WizSpin>
          <ModalPlayer {...modalProps} />
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { shortVideo } = state;
  const shortVideoInfo = modelUtils.getModelEntity(shortVideo, 'shortVideoInfo');
  const load = modelUtils.getLoadingState(state, 'shortVideo')
  return {
    shortVideoInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ShortVideoLook)

